module.exports = "../images/icons/at-location.svg";